import styled from "styled-components";

export const Container = styled.section`
  margin-top: 12rem;

  h2 {
    text-align: left;
    font-size: 3rem;
    margin-bottom: 3rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .experience-timeline {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    max-width: 100%;
    position: relative;
  }

  .experience-card {
    display: flex;
    gap: 2rem;
    padding: 2.5rem;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
    border-radius: 2rem;
    border: 1px solid rgba(102, 126, 234, 0.2);
    position: relative;
    transition: all 0.3s ease;
    backdrop-filter: blur(10px);

    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 20px 40px rgba(102, 126, 234, 0.2);
      border-color: rgba(102, 126, 234, 0.4);
    }
  }

  .experience-icon {
    flex-shrink: 0;

    .company-logo {
      width: 5rem;
      height: 5rem;
      border-radius: 1.2rem;
      object-fit: contain;
      background: white;
      padding: 0.5rem;
      box-shadow: 0 4px 15px rgba(0, 0, 0, 0.2);
    }

    .icon-badge {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 5rem;
      height: 5rem;
      border-radius: 1.2rem;
      font-weight: 700;
      font-size: 1.4rem;
      color: white;

      &.capgemini {
        background: linear-gradient(135deg, #0070ad 0%, #00a3e0 100%);
      }

      &.microsoft {
        background: linear-gradient(135deg, #f25022 0%, #00a4ef 25%, #7fba00 50%, #ffb900 75%);
      }
    }
  }

  .experience-content {
    flex: 1;

    .experience-header {
      display: flex;
      align-items: center;
      gap: 1.5rem;
      flex-wrap: wrap;
      margin-bottom: 0.5rem;

      h3 {
        font-size: 2rem;
        background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
      }

      .company {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        padding: 0.4rem 1.2rem;
        border-radius: 2rem;
        font-size: 1.2rem;
        color: white;
        font-weight: 500;
      }
    }

    .duration {
      font-size: 1.3rem;
      color: #a0a0a0;
      font-weight: 500;
      display: block;
      margin-bottom: 1.5rem;
    }

    p {
      font-size: 1.5rem;
      line-height: 1.8;
      color: #e0e0e0;
      margin-bottom: 1.5rem;
    }

    .skills-tags {
      display: flex;
      flex-wrap: wrap;
      gap: 0.8rem;

      span {
        padding: 0.5rem 1.2rem;
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(240, 147, 251, 0.2) 100%);
        border: 1px solid rgba(102, 126, 234, 0.3);
        border-radius: 2rem;
        font-size: 1.2rem;
        color: #b8b8ff;
        transition: all 0.3s ease;

        &:hover {
          background: linear-gradient(135deg, rgba(102, 126, 234, 0.4) 0%, rgba(240, 147, 251, 0.4) 100%);
          transform: translateY(-2px);
        }
      }
    }

    .documents {
      display: flex;
      gap: 1.5rem;
      margin-top: 1.5rem;
      flex-wrap: wrap;

      .doc-link {
        position: relative;
        display: flex;
        align-items: center;
        gap: 0.8rem;
        padding: 1rem 1.8rem;
        background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
        border: 2px solid transparent;
        border-radius: 1.2rem;
        color: #e0e0e0;
        font-size: 1.3rem;
        cursor: pointer;
        transition: all 0.3s ease;
        overflow: hidden;
        font-family: inherit;

        .doc-icon {
          font-size: 1.6rem;
        }

        .doc-text {
          font-weight: 500;
        }

        .shine {
          position: absolute;
          top: 0;
          left: -100%;
          width: 100%;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.2),
            transparent
          );
          animation: shine 3s infinite;
        }

        &.highlight {
          background: linear-gradient(135deg, #667eea 0%, #764ba2 50%, #f093fb 100%);
          border: 2px solid rgba(240, 147, 251, 0.5);
          box-shadow: 
            0 0 20px rgba(102, 126, 234, 0.4),
            0 0 40px rgba(118, 75, 162, 0.2),
            inset 0 0 20px rgba(255, 255, 255, 0.1);
          color: white;
          font-weight: 600;
          animation: pulse-glow 2s infinite;
        }

        &:hover {
          transform: translateY(-5px) scale(1.05);
          box-shadow: 
            0 15px 30px rgba(102, 126, 234, 0.4),
            0 0 50px rgba(240, 147, 251, 0.3);
        }
      }

      @keyframes shine {
        0% {
          left: -100%;
        }
        50%, 100% {
          left: 100%;
        }
      }

      @keyframes pulse-glow {
        0%, 100% {
          box-shadow: 
            0 0 20px rgba(102, 126, 234, 0.4),
            0 0 40px rgba(118, 75, 162, 0.2);
        }
        50% {
          box-shadow: 
            0 0 30px rgba(102, 126, 234, 0.6),
            0 0 60px rgba(240, 147, 251, 0.4);
        }
      }
    }
  }

  @media (max-width: 768px) {
    .experience-card {
      flex-direction: column;
    }

    .experience-content {
      .experience-header {
        flex-direction: column;
        align-items: flex-start;
        gap: 0.8rem;
      }
    }
  }

  @media (max-width: 480px) {
    h2 {
      font-size: 2.5rem;
    }

    .experience-card {
      padding: 1.5rem;
    }

    .experience-content {
      h3 {
        font-size: 1.6rem;
      }

      p {
        font-size: 1.4rem;
      }
    }
  }
`;

export const Modal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  padding: 2rem;
  animation: fadeIn 0.3s ease;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }
    to {
      opacity: 1;
    }
  }

  .modal-content {
    background: linear-gradient(135deg, #1a1a2e 0%, #16213e 100%);
    border-radius: 2rem;
    max-width: 90%;
    max-height: 90vh;
    width: 900px;
    overflow: hidden;
    border: 1px solid rgba(102, 126, 234, 0.3);
    box-shadow: 
      0 25px 50px rgba(0, 0, 0, 0.5),
      0 0 100px rgba(102, 126, 234, 0.2);
    animation: slideUp 0.4s ease;

    @keyframes slideUp {
      from {
        opacity: 0;
        transform: translateY(50px) scale(0.95);
      }
      to {
        opacity: 1;
        transform: translateY(0) scale(1);
      }
    }
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 1.5rem 2rem;
    background: linear-gradient(135deg, rgba(102, 126, 234, 0.2) 0%, rgba(118, 75, 162, 0.2) 100%);
    border-bottom: 1px solid rgba(102, 126, 234, 0.2);

    h3 {
      font-size: 1.8rem;
      background: linear-gradient(135deg, #667eea 0%, #f093fb 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
      background-clip: text;
      margin: 0;
    }

    .close-btn {
      width: 4rem;
      height: 4rem;
      border-radius: 50%;
      background: linear-gradient(135deg, rgba(255, 100, 100, 0.2) 0%, rgba(255, 50, 50, 0.3) 100%);
      border: 1px solid rgba(255, 100, 100, 0.3);
      color: #ff6b6b;
      font-size: 2.5rem;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: all 0.3s ease;

      &:hover {
        background: linear-gradient(135deg, rgba(255, 100, 100, 0.4) 0%, rgba(255, 50, 50, 0.5) 100%);
        transform: rotate(90deg) scale(1.1);
        box-shadow: 0 0 20px rgba(255, 100, 100, 0.4);
      }

      span {
        line-height: 1;
        margin-top: -3px;
      }
    }
  }

  .modal-body {
    padding: 2rem;
    display: flex;
    justify-content: center;
    align-items: center;
    max-height: calc(90vh - 8rem);
    overflow: auto;

    img {
      max-width: 100%;
      max-height: 70vh;
      border-radius: 1rem;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    }

    iframe {
      width: 100%;
      height: 70vh;
      border: none;
      border-radius: 1rem;
    }
  }

  @media (max-width: 768px) {
    padding: 1rem;

    .modal-content {
      max-width: 95%;
      max-height: 95vh;
    }

    .modal-header {
      padding: 1rem 1.5rem;

      h3 {
        font-size: 1.4rem;
      }

      .close-btn {
        width: 3.5rem;
        height: 3.5rem;
        font-size: 2rem;
      }
    }

    .modal-body {
      padding: 1rem;
    }
  }
`;
